export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/pinterest.b0a785ba.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};